/**
 * ADR-0013 "Defaults per business type". The server is the source of truth and applies these; the web
 * keeps a copy only to tell the owner what "Terapkan pengaturan awal" will change before they confirm.
 */
import type { BusinessType, CashierSettings } from './api/endpoints'

type Defaults = Omit<CashierSettings, 'business_type'>

const common = {
  tax_enabled: false,
  tax_rate_bps: 1000,
  service_enabled: false,
  service_rate_bps: 500,
  prices_include_tax: false,
  takeaway_fee_amount: 0,
  kitchen_ticket_copies: 1,
  receipt_show_notes: false,
  open_bill_enabled: false,
} as const

export const PROFILE_DEFAULTS: Record<BusinessType, Defaults> = {
  services: {
    ...common,
    staff_per_line_enabled: true,
    rounding_unit: 0,
    order_type_enabled: false,
    table_number_enabled: false,
    item_notes_enabled: false,
    note_presets: [],
    kitchen_ticket_enabled: false,
  },
  food: {
    ...common,
    staff_per_line_enabled: false,
    rounding_unit: 100,
    order_type_enabled: true,
    table_number_enabled: true,
    item_notes_enabled: true,
    note_presets: ['Tidak pedas', 'Pedas', 'Kuah pisah', 'Tanpa sayur', 'Bungkus terpisah'],
    kitchen_ticket_enabled: true,
  },
}

export const MAX_PRESETS = 10
export const MAX_PRESET_LENGTH = 30

/** The settings that differ between a current outlet and a profile's defaults, in display order. */
export function profileChanges(current: CashierSettings, target: BusinessType): (keyof Defaults)[] {
  const wanted = PROFILE_DEFAULTS[target]
  return (Object.keys(wanted) as (keyof Defaults)[]).filter((k) => JSON.stringify(current[k]) !== JSON.stringify(wanted[k]))
}
